import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type CertidaoResponsavelTecnicoPjJob = ReportJob;
export type CertidaoResponsavelTecnicoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão de Responsável Técnico PJ. */
@Injectable({ providedIn: 'root' })
export class CertidaoResponsavelTecnicoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-responsavel-tecnico-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.certidaoResponsavelTecnicoPj;
}
